// Pure decision behind Import fields, kept separate so the empty-detection guard is testable
// without a network layer.

/**
 * Detected fields replace the whole current list, but an EMPTY detection never does: a PDF that
 * simply declares no form fields would otherwise wipe a mapping somebody drew by hand, and nothing
 * on this page can bring it back.
 */
export const applyDetectedFields = (currentFields, detected) =>
  detected && detected.length > 0
    ? { fields: detected, imported: detected.length }
    : { fields: currentFields, imported: 0 };
